import { Link as RouterLink } from 'react-router-dom'
import { LoadingButton } from '@mui/lab'
import { Divider, Stack, Typography, Link } from '@mui/material'
import { Box } from '@mui/system'
import Logo from '../../components/logo'
import Render from '../../components/Render'
import { useWhiteLabel } from '../../hooks/useWhiteLabel'
import LoginLayout from '../../layouts/login'
import { useLocales } from '../../locales'
import AuthLoginForm from './AuthLoginForm'

// ----------------------------------------------------------------------

export default function Login() {
  const { translate } = useLocales()
  const { whitelabel } = useWhiteLabel()

  return (
    <LoginLayout>
      <Stack spacing={1} sx={{ mb: 5, position: 'relative' }}>
        <Box sx={{ pb: 2 }}>
          <Logo
            sx={{
              zIndex: 1,
              maxWidth: 120,
            }}
          />

          <Typography variant="h4">{translate('login.main')}</Typography>

          <Typography variant="body2">
            {translate('login.welcome', { whitelabel: whitelabel?.name })}
          </Typography>
        </Box>

        <AuthLoginForm />

        <Stack spacing={2} direction="row" alignItems="center" sx={{ py: 1, opacity: 0.5 }}>
          <Divider sx={{ flex: 1 }} />
          <span>ou</span>
          <Divider sx={{ flex: 1 }} />
        </Stack>

        <Render if={whitelabel.links?.signup}>
          <LoadingButton
            href={whitelabel.links?.signup}
            fullWidth
            color="inherit"
            size="large"
            type="submit"
            variant="outlined"
            sx={{ py: 3.5 }}
          >
            {translate('login.register')}
          </LoadingButton>
        </Render>

        <Stack direction="row" justifyContent="center" sx={{ mt: 3 }}>
          <Link
            component={RouterLink}
            to="/auth/operator/login"
            variant="subtitle2"
            sx={{
              color: 'text.secondary',
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
                color: 'primary.main',
              },
            }}
          >
            Entrar como operador
          </Link>
        </Stack>
      </Stack>
    </LoginLayout>
  )
}
